import { render, staticRenderFns } from "./ProgressInitFatsecretApi.vue?vue&type=template&id=22ff7060&lang=pug"
import script from "./ProgressInitFatsecretApi.vue?vue&type=script&lang=js"
export * from "./ProgressInitFatsecretApi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports